const FileServiceSignatureUrl = {
  /** 文件上传签名 */
  UPLOAD_FILE: '/acs/fs/signature-upload-file',
  // CMR 文件上传签名
  UPLOAD_FILE_CMR: '/v1/signature',
  /** 下载私有文件签名 */
  DOWNLOAD_PRIVATE_FILE: '/acs/fs/signature-download-private-file',
  /** CMR 下载私有文件签名 */
  DOWNLOAD_PRIVATE_FILE_CMR: '/v1/signature-download-private-file',
  /** 获取文件信息 */
  GET_FILE_INFO: '/acs/fs/signature-get-file-info',
  /** 下拉列表多选 */
  DELETE_FILE: '/acs/fs/signature-delete-file'
}

export default FileServiceSignatureUrl



// WEBPACK FOOTER //
// ./src/assets/js/constant/file-service-signature-url.js